export default __webpack_public_path__ + "static/media/photo--sm--ish-2.5752d2dd.jpg";